// Categorías de casos/reportes laborales compartidas entre empresa, colaborador y admin

export interface CaseCategory {
  value: string
  label: string
}

// Categorías cuando la EMPRESA reporta a un COLABORADOR
export const CASE_CATEGORIES_TO_COLLABORATOR: CaseCategory[] = [
  { value: 'robo', label: 'Robo' },
  { value: 'fraude', label: 'Fraude' },
  { value: 'abandono_laboral', label: 'Abandono laboral' },
  { value: 'acoso', label: 'Acoso' },
  { value: 'incumplimiento_grave', label: 'Incumplimiento grave' },
  { value: 'otro', label: 'Otro' },
]

// Categorías cuando el COLABORADOR reporta a una EMPRESA
export const CASE_CATEGORIES_TO_COMPANY: CaseCategory[] = [
  { value: 'incumplimiento_salarial', label: 'Incumplimiento salarial' },
  { value: 'acoso_laboral', label: 'Acoso laboral' },
  { value: 'discriminacion', label: 'Discriminación' },
  { value: 'malas_condiciones', label: 'Malas condiciones laborales' },
  { value: 'otro', label: 'Otro' },
]

export const CASE_STATUS_META: Record<string, { label: string; cls: string }> = {
  abierto: { label: 'Abierto', cls: 'bg-blue-50 text-blue-700' },
  en_revision: { label: 'En revisión', cls: 'bg-amber-50 text-amber-700' },
  validado: { label: 'Validado', cls: 'bg-emerald-50 text-emerald-700' },
  rechazado: { label: 'Rechazado', cls: 'bg-red-50 text-red-600' },
}

const ALL_CATEGORIES = [...CASE_CATEGORIES_TO_COLLABORATOR, ...CASE_CATEGORIES_TO_COMPANY]

export function categoryLabel(value: string): string {
  return ALL_CATEGORIES.find((c) => c.value === value)?.label || value
}
